var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 18,
    viewBox: "0 0 33 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.988281,
    width: 31.0263,
    height: 17.8158,
    rx: 4.01316,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.65495 12.4082V5.6661H7.11895L9.26679 9.94252L11.3857 5.6661H12.8497V12.4082H11.6169V7.75615L9.73874 11.445H8.76595L6.88779 7.75615V12.4082H5.65495ZM17.211 12.5238C16.5304 12.5238 15.9461 12.3793 15.4581 12.0904C14.9701 11.795 14.5945 11.3873 14.3312 10.8672C14.0679 10.3406 13.9363 9.73383 13.9363 9.04678C13.9363 8.35973 14.0679 7.75294 14.3312 7.22641C14.5945 6.69989 14.9701 6.28894 15.4581 5.99357C15.9461 5.6982 16.5304 5.55052 17.211 5.55052C18.0201 5.55052 18.6815 5.75278 19.1951 6.15731C19.7152 6.55541 20.0395 7.11726 20.1679 7.84283H18.8099C18.7264 7.47683 18.5466 7.1911 18.2705 6.98562C18.0008 6.77373 17.6412 6.66778 17.1918 6.66778C16.5689 6.66778 16.0809 6.87968 15.7278 7.30347C15.3746 7.72726 15.198 8.30836 15.198 9.04678C15.198 9.7852 15.3746 10.3663 15.7278 10.7901C16.0809 11.2075 16.5689 11.4162 17.1918 11.4162C17.6412 11.4162 18.0008 11.3198 18.2705 11.1272C18.5466 10.9282 18.7264 10.6553 18.8099 10.3085H20.1679C20.0395 11.002 19.7152 11.5446 19.1951 11.9363C18.6815 12.3279 18.0201 12.5238 17.211 12.5238ZM20.7412 12.4082L23.2068 5.6661H24.5938L27.0595 12.4082H25.7496L25.2102 10.8479H22.5808L22.0318 12.4082H20.7412ZM22.9179 9.88473H24.8731L23.8907 7.08194L22.9179 9.88473Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMca);
export default __webpack_public_path__ + "static/media/mca.6961488d5d3c75b1b412ace9e3f9c162.svg";
export { ForwardRef as ReactComponent };